import React from 'react';
import { Image, StyleSheet, View } from 'react-native';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

export const Logo: React.FC<LogoProps> = ({ size = 'medium' }) => {
  const dimensions = {
    small: { width: 80, height: 24 },
    medium: { width: 120, height: 36 },
    large: { width: 160, height: 48 },
  };

  return (
    <View style={styles.container}>
      <Image
        source={require('@/assets/images/vida-logo-new.svg')}
        style={[styles.logo, dimensions[size]]}
        resizeMode="contain"
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 48,
  },
  logo: {
    // Dimensions set by props
  },
});
